import { makeObservable } from 'mobx'
import { collection } from '../../infra/collection'
import { WorkspaceInvitationDTO } from '../workspace-postings-opportunities/dtos/workspace-posting-opportunity'
import { WorkspacePostingOpportunitiesAPI } from '../workspace-postings-opportunities/API'
import { defer, merge, Observable } from 'rxjs'
import { mergeMap, filter, map, share } from 'rxjs/operators'
import { whileActive } from '../../utils/rx-util'
import WorkspaceInvitation from './WorkspaceInvitation'

export default class WorkspaceOpportunityInvitationStore {
  workspaceInvitations = collection<
    WorkspaceInvitationDTO,
    WorkspaceInvitation
  >({
    create: () => new WorkspaceInvitation(),
  })

  /**
   * Emits pending offers. Used on first load.
   */
  private readonly _invitationsFromFetch$ = defer(async () =>
    this.opsAPI.listInvitations({
      limit: 100,
    }),
  ).pipe(mergeMap((resp) => resp.data))

  /**
   * Observable of incoming invitations.
   * TODO: Add RTE observable when RTE is added
   */
  readonly incomingInvitations$: Observable<WorkspaceInvitation> = merge(
    this._invitationsFromFetch$,
  ).pipe(
    whileActive(this.canViewOpportunities$),
    filter((x) => !this.workspaceInvitations.get(x.id)),
    map((x) => this.workspaceInvitations.set(x)),
    share(),
  )

  constructor(
    private opsAPI: WorkspacePostingOpportunitiesAPI,
    private readonly canViewOpportunities$: Observable<boolean>,
  ) {
    makeObservable(this, {})
  }

  async acceptInvitation(invitationId: string) {
    const invitation = this.workspaceInvitations.get(invitationId)
    if (!invitation) {
      return
    }
    await this.opsAPI.acceptInvitation(invitationId).then(() => {
      this.workspaceInvitations.remove(invitationId)
    })
  }

  async rejectInvitation(invitationId: string) {
    const invitation = this.workspaceInvitations.get(invitationId)
    if (!invitation) {
      return
    }
    await this.opsAPI.rejectInvitation(invitationId).then(() => {
      this.workspaceInvitations.remove(invitationId)
    })
  }
}
